import {
  ReportSection,
  SavedReportSection,
  UserCustomisableChartConfig,
} from 'app/modules/reportDashboards/models';

export const getSavableReportDashboardConfig = (
  config: ReportSection[],
): SavedReportSection[] =>
  config.map((section) => ({
    id: section.id,
    charts: section.charts.map((chart) => ({
      id: chart.id,
      enabled: chart.enabled,
      chartType: chart.chartType,
    })),
  }));

export const mergeReportDashboardConfig = (
  savedConfig: SavedReportSection[],
  defaultConfig: ReportSection[],
): ReportSection[] => {
  const defaultConfigMap = savedConfig.reduce<
    Record<string, Record<string, UserCustomisableChartConfig>>
  >((acc, section) => {
    acc[section.id] = section.charts.reduce(
      (innerAcc, chart) => ({
        ...innerAcc,
        [chart.id]: chart,
      }),
      {},
    );
    return acc;
  }, {});

  return defaultConfig.map((section) => ({
    ...section,
    charts: section.charts.map((chart) => ({
      ...chart,
      // Check needed to ensure that the latest section and key exist within saved state,
      // else nothing to copy over from saved state
      ...(defaultConfigMap[section.id] && defaultConfigMap[section.id][chart.id]
        ? defaultConfigMap[section.id][chart.id]
        : {}),
    })),
  }));
};
